exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".component-display {\n  background-color: #858694;\n  color: white;\n  text-align: right;\n  font-weight: 200;\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.component-display > div {\n  font-size: 2.5rem;\n  padding: 0.2rem 0.7rem 0.1rem 0.5rem;\n}\n", ""]);

